export default "__VITE_ASSET__D6Ytk0sw__"